import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import { getFormattedText } from '../utils/remirrorUtils';
import CommentMentionTag from './CommentMentionTag';

interface CommentBoxContentProps {
  text: string;
}

const useStyles = makeStyles()(theme => ({
  pre: {
    whiteSpace: 'break-spaces',
    overflowWrap: 'break-word',
  },
}));

const CommentBoxContent = (props: CommentBoxContentProps) => {
  const { classes } = useStyles();
  const { text } = props;

  const formattedTextResults = getFormattedText(text);

  return (
    <Typography variant="pSm" component="pre" className={classes.pre}>
      {formattedTextResults.map(item => {
        if (item.isMention && item.userId)
          return <CommentMentionTag key={item.id} userId={item.userId} />;
        return <React.Fragment key={item.text}>{item.text}</React.Fragment>;
      })}
    </Typography>
  );
};

export default CommentBoxContent;
